import React from "react";
import { MyTasksListKey, TaskNote } from "../../../redux/myTasks";
import SectionHeading from "./SectionHeading";
import TaskListItem from "./TaskListItem";

export interface TaskSectionProps {
  /** Omit for a run of rows with no heading of their own (e.g. Your Tasks' "rest"). */
  heading?: string;
  tab: MyTasksListKey;
  notes: TaskNote[];
  onToggleComplete: (noteId: string, complete: boolean) => void;
}

/** A run of task rows, with an optional heading above the first row. Renders nothing when empty. */
const TaskSection = ({ heading, tab, notes, onToggleComplete }: TaskSectionProps) => {
  if (notes.length === 0) {
    return null;
  }

  return (
    <>
      {heading && <SectionHeading>{heading}</SectionHeading>}
      {notes.map((note, i) => (
        <TaskListItem
          key={note.note_id}
          tab={tab}
          note={note}
          onToggleComplete={onToggleComplete}
          paddingTop={heading && i === 0 ? "0" : undefined}
        />
      ))}
    </>
  );
};

export default TaskSection;
